// Modified from ActiveStorage helpers.js
export function getMetaValue(name: string) {
  const element = document.head.querySelector(`meta[name="${name}"]`);
  if (element) {
    return element.getAttribute('content');
  }
  return null;
}
